import {combineReducers, configureStore} from "@reduxjs/toolkit";
import appReducer from './reducers/AppSlice'
import authReducer from './reducers/AuthSlice'
import modulesReducer from  './reducers/ModulesSlice'

const rootReducer = combineReducers({
    appReducer,
    authReducer,
    modulesReducer,
})

export const setupStore = () => {
    return configureStore(({
        reducer: rootReducer
    }))
}

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']